import {
  Card,
  Container,
  Stack,
  Tab,
  Tabs,
  tabsClasses,
  useTheme,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { getLoggedInUser } from "src/auth/utils";
import { useSettingsContext } from "src/components/settings";
import StudentController from "src/controller/Student.controller";
import AssessmentsPage from "./Assessment/AssessmentsPage";
import DetailsPage from "./DetailsPage";
import EnrollmentPage from "./EnrollmentPage";
import LearningPage from "./Learning/LearningPage";
import ProfileCover from "./ProfileCover";
import ReportPage from "./Report/ReportPage";
import StudentScheduleView from "../schedule/StudentScheduleView";
// ----------------------------------------------------------------------

export default function StudentProfilePage({ setValue, control }) {
  const { themeStretch } = useSettingsContext();
  const [id, setId] = useState(null);
  // const id = getLoggedInUser()?.student_id;
  const theme = useTheme();
  const { tab } = useParams();
  const [currentTab, setCurrentTab] = useState("details");
  const [student, setStudent] = useState(null);
  const [enrollments, setEnrollments] = useState([]);

  const TABS = [
    { value: "details", label: "Details" },
    { value: "enrollments", label: "Enrollments" },
    { value: "assessments", label: "Assessments" },
    { value: "learning-plans", label: "Learning Plans" },
    { value: "report", label: "Report" },
    { value: "schedule", label: "Schedule" },
  ];

  const handleChangeTab = useCallback((event, newValue) => {
    setCurrentTab(newValue);
    // Push new tab to the url
    window.history.pushState({}, "", `/student/${newValue}`);
  }, []);

  useEffect(() => {
    if (id) {
      StudentController.getDetails(id)
        .then((data) => setStudent(data))
        .catch((err) => console.log(`Api Error: ${err.message}`));

      StudentController.getEnrollments(id)
        .then((data) =>
          setEnrollments((data || []).filter((i) => i.status === "active"))
        )
        .catch((err) => {
          console.log(`Api Error: ${err.message}`);
          setEnrollments([]);
        });
    }
  }, [id]);

  useEffect(() => {
    if (
      [
        "details",
        "enrollments",
        "assessments",
        "learning-plans",
        "report",
        "schedule",
      ].includes(tab)
    ) {
      setCurrentTab(tab);
    } else if (window.location.href.includes("assessments")) {
      setCurrentTab("assessments");
    } else {
      window.redirect("/404");
    }
  }, [tab]);

  useEffect(() => {
    if (getLoggedInUser()?.role != "student") {
      window.redirect("/dashboard/app");
    }

    if (getLoggedInUser()?.role === "student") {
      setId(getLoggedInUser()?.student_id);
    }
  }, []);

  const displayName =
    `${student?.first_name || ""} ${student?.last_name || ""}`.trim() || "-";

  return (
    <Container maxWidth={themeStretch ? false : "lg"} sx={{ maxWidth: "85%" }}>
      <Card sx={{ mb: 3, bgcolor: "#fff" }}>
        <Stack>
          <Stack
            sx={{
              height: 200,
              bgcolor: theme.palette.primary.light,
              position: "relative",
              borderBottom: "2px solid #f0f0f0",
              mb: 1,
            }}
          >
            <ProfileCover
              role="Student"
              name={displayName}
              enrolled={enrollments?.length ?? 0}
            />
            <Tabs
              value={currentTab}
              onChange={handleChangeTab}
              sx={{
                width: 1,
                bottom: 0,
                position: "absolute",
                bgcolor: "#fff",
                [`& .${tabsClasses.flexContainer}`]: {
                  pr: { md: 3 },
                  justifyContent: { sm: "center", md: "flex-end" },
                },
              }}
            >
              {TABS.map((tab) => (
                <Tab key={tab.value} value={tab.value} label={tab.label} />
              ))}
            </Tabs>
          </Stack>
          {currentTab === "details" && <DetailsPage student={student} />}
          {currentTab === "enrollments" && (
            <EnrollmentPage enrollments={enrollments} />
          )}
          {currentTab === "assessments" && (
            <AssessmentsPage
              enrollments={enrollments}
              student={student}
              hideActions
            />
          )}
          {currentTab === "learning-plans" && (
            <LearningPage
              enrollments={enrollments}
              student={student}
              readOnly
            />
          )}
          {currentTab === "report" && (
            <ReportPage
              enrollments={enrollments}
              student={student}
              hideAdd={true}
            />
          )}
          {currentTab === "schedule" && <StudentScheduleView />}
        </Stack>
      </Card>
    </Container>
  );
}
